module.exports = __webpack_public_path__ + "img/swish.b0b9edf1.svg";